document.addEventListener('DOMContentLoaded', function() {
    const specialCursorArea = document.querySelector('.special-cursor-area');

    specialCursorArea.addEventListener('mousemove', (e) => {
        const cursor = document.getElementById('custom-cursor');
        cursor.style.left = e.pageX + 'px';
        cursor.style.top = e.pageY + 'px';
    });

    specialCursorArea.addEventListener('mouseenter', () => {
        const cursor = document.getElementById('custom-cursor');
        cursor.style.display = 'block';
    });

    specialCursorArea.addEventListener('mouseleave', () => {
        const cursor = document.getElementById('custom-cursor');
        cursor.style.display = 'none';
    });
});
